var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUser(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.677 17.87c-2.04 0-4.084.005-6.124-.003-1.197-.004-2.015-.548-2.354-1.53-.336-.968-.078-2.064.879-2.669 1.537-.968 3.16-1.802 4.766-2.66.163-.087.47.003.674.097 1.48.65 2.944.654 4.432.017.257-.11.65-.127.887-.009a88.59 88.59 0 014.165 2.24c1.23.712 1.693 1.906 1.264 3.034-.368.965-1.137 1.471-2.306 1.48-2.093.012-4.19.008-6.283.004zM4.12 5.57C4.114 2.193 6.497-.206 9.314.158c1.688.216 2.8 1.25 3.511 2.739 1.002 2.097.585 4.725-.989 6.303-1.194 1.194-2.629 1.664-4.26 1.174-1.843-.552-2.837-1.93-3.299-3.733-.106-.42-.13-.862-.16-1.07h.001z"
  }))));
}

export default SvgUser;